import { createContext, useState } from "react";

const DataContext = createContext<any>({});

export const DataProvider = ({ children }) => {
  const [errors, setErrors] = useState([]);
  const [successMsgs, setSuccessMsgs] = useState([]);
  const [authErrors, setAuthErrors] = useState([]);
  const [authErrorObject, setAuthErrorObject] = useState([]);

  const [auth, setAuth] = useState(false);
  const [user, setUser] = useState({
    user: "",
    phone: "",
    email: "",
    username: "",
  });

  const setUserData = (data) => {
    let size = Object.keys(data)?.length;
    if (!size) {
      setUser({
        user: "",
        phone: "",
        email: "",
        username: "",
      });
    } else {
      setUser({
        phone: data?.phone,
        user: data?.user,
        email: data?.email,
        username: data?.username,
      });
    }
  };

  return (
    <DataContext.Provider
      value={{
        auth,
        user,
        setUserData,
        errors,
        authErrors,
        authErrorObject,
        successMsgs,
        setAuthErrors,
        setAuthErrorObject,
        setAuth,
        setErrors,
        setSuccessMsgs,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
export default DataContext;
